"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-15eb08d7"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "position-relative" };
var _hoisted_2 = ["name", "value"];
var _hoisted_3 = ["name", "value"];
var _hoisted_4 = ["name", "value"];
var _hoisted_5 = ["name", "value"];
var _hoisted_6 = { class: "subtotal-td" };
var _hoisted_7 = ["name", "value"];
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("i", { class: "bi bi-trash-fill" }, null, -1); });
var _hoisted_9 = [
    _hoisted_8
];
var vue_3 = require("vue");
var tom_select_1 = __importDefault(require("tom-select"));
exports.default = (0, vue_1.defineComponent)({
    name: 'ServiceItem',
    props: {
        index: { type: Number, required: true },
        item: {
            type: Object,
            required: false
        }
    },
    emits: ['removed'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var subTotal = (0, vue_3.ref)(0);
        var service = (0, vue_3.ref)(null);
        var price = (0, vue_3.ref)(0);
        var quantity = (0, vue_3.ref)(1);
        var serviceElm = (0, vue_3.ref)(null);
        var setting = {
            valueField: 'id',
            labelField: 'name',
            searchField: ['name'],
            create: false,
            maxItems: 1,
            closeAfterSelect: true,
            loadThrottle: 500,
            shouldLoad: function (query) {
                return query.length > 2;
            },
            load: function (query, callback) {
                globalThis.axios
                    .get('/api/services', { params: { q: query } })
                    .then(function (response) {
                    callback(response.data, []);
                });
            },
            render: {
                item: function (item, escape) {
                    service.value = item;
                    price.value = item.price * 1;
                    return "\n                    <div>\n                        ".concat(item.name, "\n                    </div>\n                ");
                },
                option: function (item, escape) {
                    return "\n                    <div>\n                        ".concat(item.name, "\n                    </div>\n                ");
                }
            }
        };
        var sumTotal = (0, vue_3.inject)('sumTotal');
        function remove() {
            emit('removed');
        }
        (0, vue_3.watch)([price, quantity], function (_a) {
            var newPrice = _a[0], newQuantity = _a[1];
            subTotal.value = ((newPrice + (['B', 'D'].includes(service.value.type) ? service.value.specific_tax * 1.18 : service.value.specific_tax)) * newQuantity);
            sumTotal({
                service_id: service.value.id,
                price: newPrice,
                quantity: newQuantity,
                total: subTotal.value
            }, props.index);
        });
        (0, vue_3.onMounted)(function () {
            if (props.item) {
                Object.assign(setting, {
                    options: [props.item.service],
                    items: [props.item.service.id],
                    onInitialize: function () {
                        service.value = props.item.service;
                        price.value = props.item.price * 1;
                        quantity.value = props.item.quantity * 1;
                    }
                });
            }
            new tom_select_1.default(serviceElm.value, setting);
        });
        return function (_ctx, _cache) {
            var _a, _b;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_1, [
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.createElementVNode)("input", {
                        ref_key: "serviceElm",
                        ref: serviceElm,
                        type: "text",
                        class: "form-control",
                        placeholder: "Service"
                    }, null, 512),
                    (0, vue_2.createElementVNode)("input", {
                        type: "hidden",
                        name: "items[".concat(__props.index, "][service_id]"),
                        value: (_a = service.value) === null || _a === void 0 ? void 0 : _a.id
                    }, null, 8, _hoisted_2),
                    (__props.item)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                            key: 0,
                            type: "hidden",
                            name: "items[".concat(__props.index, "][id]"),
                            value: __props.item.id
                        }, null, 8, _hoisted_3))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((price).value = $event); }),
                        type: "number",
                        step: "1",
                        class: "form-control",
                        placeholder: "Prix Unitaire"
                    }, null, 512), [
                        [vue_2.vModelText, price.value]
                    ]),
                    (0, vue_2.createElementVNode)("input", {
                        type: "hidden",
                        name: "items[".concat(__props.index, "][price]"),
                        value: price.value
                    }, null, 8, _hoisted_4)
                ]),
                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((_b = service.value) === null || _b === void 0 ? void 0 : _b.specific_tax), 1),
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((quantity).value = $event); }),
                        type: "number",
                        class: "form-control",
                        placeholder: "Quantité"
                    }, null, 512), [
                        [vue_2.vModelText, quantity.value]
                    ]),
                    (0, vue_2.createElementVNode)("input", {
                        type: "hidden",
                        name: "items[".concat(__props.index, "][quantity]"),
                        value: quantity.value
                    }, null, 8, _hoisted_5)
                ]),
                (0, vue_2.createElementVNode)("td", _hoisted_6, [
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(subTotal.value) + " ", 1),
                    (0, vue_2.createElementVNode)("input", {
                        type: "hidden",
                        name: "items[".concat(__props.index, "][total]"),
                        value: subTotal.value
                    }, null, 8, _hoisted_7)
                ]),
                (0, vue_2.createElementVNode)("button", {
                    onClick: remove,
                    class: "btn btn-link btn-danger position-absolute",
                    type: "button"
                }, _hoisted_9)
            ]));
        };
    }
});
